import React, { useState, useEffect } from "react"
import { Breadcrumb, notification, Tabs } from "antd"
import MetaTags from "react-meta-tags"
import { resetChangePasswordFlag, resetUSERFlag } from "store/actions"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import UserFiles from "./UserFiles"
import UserProfile from "./user-profile"
import EngLeave from "./eng-leave"
import { getCurrentUser } from "helpers/service_helper"

const GasProjectDashboardEng = props => {
  const {
    loading,
  } = props
  const [api, contextHolder] = notification.useNotification()
  const [errorMessage, setErrorMessage] = useState(null)
  const openNotification = (type, placement, message) => {
    api[type]({
      message,
      placement,
    })
  }

  useEffect(() => {
    if (props.success) openNotification("success", "top", props.success)
    if (props.error) openNotification("error", "top", props.error)
    if (errorMessage) openNotification("warning", "top", props.error)
        props.onResetUSERFlag()
    props.onResetChangePasswordFlag()
  }, [errorMessage, props.success, props.error])

  const [activeKey, setActiveKey] = useState("1")

  // Breadcrumb configuration
  const breadcrumbItems = [
    { title: "داشبورد", path: "/dashboard" },
    { title: "پروفایل", path: "/profile" },
  ].map((item, index) => ({
    key: index,
    title: <a href={item.path}>{item.title}</a>,
  }))

  // Tabs configuration
  const currentUser = getCurrentUser()
  const role = currentUser ? currentUser.role : null
  const hasRole = r => (Array.isArray(role) ? role.includes(r) : role === r)

  const tabItems = [
    {
      key: "1",
      label: "فایل های من",
      children: <UserFiles />, // Directly render pre-imported component
    },
    {
      key: "2",
      label: "تغییر رمز عبور",
      children: <UserProfile />, // Directly render pre-imported component
    },
    // include tab 3 only for Administrator or Engineer
    (hasRole("Administrator") || hasRole("Engineer")) && {
      key: "3",
      label: "درخواست مرخصی",
      children: <EngLeave />,
    },
  ].filter(Boolean)

  const handleTabChange = key => {
    setActiveKey(key)
  }

  return (
    <div className="page-content page-content--full-height">
      <MetaTags>
        <title>پروفایل | واحد گاز</title>
      </MetaTags>
      {/* Breadcrumb with arrow separator */}
      <Breadcrumb
        separator=">"
        style={{ margin: "16px 0", fontSize: "14px" }}
        items={breadcrumbItems}
      />
      {contextHolder}

            <Tabs
              className="pt-2"
              activeKey={activeKey}
              onChange={handleTabChange}
              items={tabItems}
              type="card"
              destroyInactiveTabPane={true}
            />
    </div>
  )
}

const mapStateToProps = ({USERs, ChangePassword, Engineers}) => ({
    error: USERs.error || ChangePassword.error || Engineers.error,
    success: USERs.success || ChangePassword.success || Engineers.success,
    loading: USERs.loading || ChangePassword.loading || Engineers.loading,
})

const mapDispatchToProps = dispatch => ({
  onResetUSERFlag: searchValue => dispatch(resetUSERFlag(searchValue)),
  onResetChangePasswordFlag: () => dispatch(resetChangePasswordFlag())
  
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(GasProjectDashboardEng))
